import styled from 'styled-components'

import { useHapticFeedback } from '@blade/ui-kit'
import {
  CrossIcon,
  EditIcon,
  Separator as Separator_,
} from '@root/shared/ui-kit'

import type { LimitOrderModel } from '../../../atoms'

type Props = {
  onEdit?: (order: LimitOrderModel) => void
  onClose?: (order: LimitOrderModel) => void
  order: LimitOrderModel
}

export const LimitOrderItemActions: React.FC<Props> = ({
  order,
  onEdit,
  onClose,
}) => {
  const haptics = useHapticFeedback()

  const handleEditClick = () => {
    haptics.impactOccurred('light')
    onEdit?.(order)
  }

  const handleCloseClick = () => {
    haptics.impactOccurred('light')
    onClose?.(order)
  }

  return (
    <Root>
      <IconButton type="button" onClick={handleCloseClick}>
        <CrossIcon size={16} />
      </IconButton>
      <Separator />
      <IconButton type="button" onClick={handleEditClick}>
        <EditIcon size={16} />
      </IconButton>
    </Root>
  )
}

const Root = styled.div`
  border-inline-start: 1px solid var(--backgroundA-2);

  display: grid;
  grid-template-rows: 1fr auto 1fr;

  align-items: center;
  height: 100%;
  width: 30px;
  justify-items: center;
`

const Separator = styled(Separator_)`
  background: var(--backgroundA-2);
  width: 100%;
`
const IconButton = styled.button`
  all: unset;
  cursor: pointer;
  display: grid;
  align-content: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`
